import React from "react";
import { Row, Col } from "react-bootstrap";
import { styles } from "./style.ts";
import { Button } from "../../Shared/FormHelpers";

const SearchForm = ({ keywords, location, handleChange, handleSubmit }) => (
  <>
    <h2 style={{ ...styles.green, margin: "40px 0 20px" }}>Search Jobs</h2>
    <input
      style={styles.input}
      type="text"
      name="keywords"
      value={keywords ?? ""}
      placeholder="Job title, Keywords or Company name"
      className="form-control"
      onChange={handleChange}
    />
    <Row>
      <Col md={8} style={{ marginTop: 10 }}>
        <input
          style={styles.input}
          type="text"
          name="location"
          value={location ?? ""}
          placeholder="City or State"
          className="form-control"
          onChange={handleChange}
        />
      </Col>
      <Col md={4} style={{ marginTop: 10 }}>
        <Button
          type="button"
          value="Search"
          style={{ width: "100%", background: "#0071bc" }}
          className="btn btn-lg btn-primary"
          handleSubmit={handleSubmit}
        />
      </Col>
    </Row>
  </>
);

export default SearchForm;
